import { render } from "./ClientsListView.vue?vue&type=template&id=9df7a1ea"
import script from "./ClientsListView.vue?vue&type=script&lang=js"
export * from "./ClientsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__